import { PageSize } from "./components/page-size";
import { Pagination } from "./components/pagination";
import { TableFooterProps } from "./types";
import { getTotalPages } from "./utils";
import styles from "./styles.module.scss";

export const TableFooter = ({
  currentPage,
  pageSize,
  totalElements,
  availablePageSizes,
  onPageChange,
  onPageSizeChange,
  dataTestId = "table-footer",
}: TableFooterProps) => {
  const totalPages = getTotalPages(totalElements, pageSize);
  const isLastPage = currentPage >= totalPages;

  const handlePageSizeChange = (pageSize: number) => {
    onPageChange(1);
    onPageSizeChange(pageSize);
  };

  return (
    <div className={styles.footer} data-test-id={dataTestId}>
      <div className={styles.inner}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          dataTestId={`${dataTestId}-pagination`}
          onPageChange={onPageChange}
        />
        <PageSize
          currentPage={currentPage}
          pageSize={pageSize}
          totalElements={totalElements}
          isLastPage={isLastPage}
          availablePageSizes={availablePageSizes}
          dataTestId={`${dataTestId}-page-size`}
          onPageSizeChange={handlePageSizeChange}
        />
      </div>
    </div>
  );
};
